// extracted by mini-css-extract-plugin
export default {"addToCartControl":"pY-z","giftCard":"qY-z","btnContainer":"rY-z","cartButton":"sY-z","disabled":"tY-z"};